
// src/pages/LibraryPage.jsx
import React, { useState } from 'react';
import { useLibrary } from '../context/LibraryContext';
import AlbumGrid from '../components/library/AlbumGrid';
import ReleaseModal from '../components/library/ReleaseModal';
import AudioPlayer from '../components/library/AudioPlayer';

const DiscographyPage = () => {
  const { loading, error } = useLibrary();
  const [modalOpen, setModalOpen] = useState(false);

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-12 flex justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-purple-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-12">
        <div className="bg-red-900 text-white p-4 rounded">
          <p>Error: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8 relative min-h-screen">
      <h1 className="text-4xl font-bold mb-8 text-gray-100">Discography</h1>
      
      <AlbumGrid onOpenModal={() => setModalOpen(true)} />
      
      {modalOpen && (
        <ReleaseModal onClose={() => setModalOpen(false)} />
      )}
      
      <div className="fixed bottom-0 left-0 right-0 z-50">
        <AudioPlayer />
      </div>
    </div>
  );
};

export default DiscographyPage;